import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checked from "../imagem/checked.png";

function ConfirmacaoAvaliacao({
  openModalConf,
  setOpenModalConf,
  nome,
  text,
  tam,
  fecharModal
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {openModalConf && (
        <div>
          <Modal
            open={openModalConf}
            onClose={fecharModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: tam,
                height: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 5,
                gap: 4,
                borderRadius: "24px",
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontSize: "1.4rem",
                  color: "var(--cor-roxoEscuro)",
                  fontWeight: 500,
                  fontStyle: "Medium",
                  textAlign: "center",
                }}
              >
                {nome}
              </Typography>

              <img src={checked} />

              <Typography
                id="modal-modal-description"
                sx={{
                  fontSize: "1.2rem",
                  textAlign: "center",
                  color: "var(--cor-preto)",
                }}
              >
                {text}
              </Typography>
            </Box>
          </Modal>
        </div>
      )}
    </div>
  );
}

export default ConfirmacaoAvaliacao;
